export class EmptyStoreDefinition {
	private isLoading = false;
}
